import React from 'react';
import { Provider } from 'react-redux';
import { createStore } from 'redux';
import InterestDetailsContainer from './InterestDetails';
import rootReducer from '../../../reducers';
var store = createStore(rootReducer);
function InterestDetails(props) {
  return /*#__PURE__*/React.createElement(Provider, {
    store: store
  }, /*#__PURE__*/React.createElement(InterestDetailsContainer, props));
}
export default InterestDetails;